import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
import {deckHerosApi, realGamesApi, OPERATOR_ID} from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getUsers() {
    try {
        // const response = await serviceContext.get("manage/users/list", null, options);
        const response = await serviceContext.get(`${ReportsURL}user/list`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUsersVsOnlyClient(isOnlyClients = false) {
    try {
        // const response = await serviceContext.get("manage/users/list", null, options);
        const response = await serviceContext.get(`${ReportsURL}user/list${isOnlyClients?'/role/Client':''}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUsersVsOnlyClientNew(data) {
    try {
        // const response = await serviceContext.get("manage/users/list", null, options);
        const response = await serviceContext.post(`${ReportsURL}user/list/page`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getClientParentSharing(usr) {
    try {
        // const response = await serviceContext.get("manage/users/list", null, options);
        const response = await serviceContext.get(`${ReportsURL}user/sharing/${usr}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUsersById(uid) {
    try {
        // const response = await serviceContext.get("manage/users/list/"+uid, null, options);
        const response = await serviceContext.get(`${ReportsURL}user/list/${uid}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUser(user_name) {
    try {
        // const response = await serviceContext.get(`${ReportsURL}user/detail/${user_name}` + user_name, null, options);
        const response = await serviceContext.get("manage/users/detail/" + user_name, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function addUser(data) {
    try {
        const response = await serviceContext.post("manage/users", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function updateUser(data) {
    try {
        const response = await serviceContext.put("manage/users", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function activeUser(data) {
    try {
        const response = await serviceContext.post("manage/users/activate", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function activeRealGamesUser(user_id) {
    try {
        // const response = await serviceContext.post(deckHerosApi + "/user/activate/" + OPERATOR_ID + "/" + user_id, null, options);
        const response = await serviceContext.get(realGamesApi + "/user/userunlock/" + OPERATOR_ID + ":" +user_id, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActiveUser(data) {
    try {
        const response = await serviceContext.post("manage/users/deactivate", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActiveRealGamesUser(user_id) {
    try {
        // const response = await serviceContext.post(deckHerosApi + "/user/deactivate/" + OPERATOR_ID + "/" + user_id, null, options);
        const response = await serviceContext.get(realGamesApi + "/user/userlock/" + OPERATOR_ID + ":" + user_id, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function blockUser(data) {
    try {
        const response = await serviceContext.post("manage/users/block", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function blockRealGamesUser(user_id) {
    try {
        // const response = await serviceContext.post(deckHerosApi + "/user/betlock/" + OPERATOR_ID + "/" + user_id, null, options);
        const response = await serviceContext.get(realGamesApi + "/user/betlock/" + OPERATOR_ID + ":" + user_id, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function unBlockUser(user) {
    try {
        const response = await serviceContext.post("manage/users/unblock", JSON.stringify(user), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function unBlockRealGamesUser(user_id) {
    try {
        // const response = await serviceContext.post(deckHerosApi + "/user/betunlock/" + OPERATOR_ID + "/" + user_id, null, options);
        const response = await serviceContext.get(realGamesApi + "/user/betunlock/" + OPERATOR_ID + ":" + user_id, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function changePassword(data) {
    try {
        const response = await serviceContext.post("affiliate/users/changepassword", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function setPassword(data) {
    try {
        const response = await serviceContext.post("manage/profile/changepassword", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getProfileLimit() {
    try {
        const response = await serviceContext.get("manage/profile/limits", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function updateUserPassword(data) {
    try {
        const response = await serviceContext.post("manage/users/password", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postUserList(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "userslistdata", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUsernameCheck(username) {
    try {
        const response = await serviceContext.get("manage/users/checkusername/"+username, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserMarketExposure(username,mkt) {
    try {
        const response = await serviceContext.get(`${ReportsURL}result/open/market/user/${username}/${mkt}`, null, options); //+ "results/markets/user/"+username+"/"+mkt, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserSearch(parent ,username) {
    try {
        const response = await serviceContext.get(`${ReportsURL}user/search/${parent}/${username}`, null, options); //+ "users/search/"+parent+"/"+username, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserSearchDetail(parent ,username) {
    try {
        const response = await serviceContext.get(`${ReportsURL}user/search/detail/${parent}/${username}`, null, options); //+ "users/search/detail/"+parent+"/"+username, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserParentSearch(parent ,username) {
    try {
        const response = await serviceContext.get(`${ReportsURL}user/search/parent/${parent}/${username}`, null, options); //+ "users/search/parent/"+parent+"/"+username, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getRealGamesUsersByUserName(uid) {
    try {
        const response = await serviceContext.get(deckHerosApi + "/user/detail/"+ OPERATOR_ID + "/" +uid, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getRealGamesChildUsers(uid) {
    try {
        const response = await serviceContext.get(deckHerosApi + "/user/child/list/"+ OPERATOR_ID + "/" +uid, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getRealGamesUserBalance(user_id) {
    try {
        const response = await serviceContext.get(`${realGamesApi}/user/balance/${user_id}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function resetPassword(data) {
    try {
        const response = await serviceContext.post("affiliate/users/resetpassword", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};